<template>
  <div
    v-if="whitelabelStatus.customDomainStatus !== null"
    class="setup_step card"
  >
    <h4>Custom domain status</h4>
    <div
      v-if="!canContinueToSetup"
      class="text-danger"
      v-html="unableToContinueMessage"
    />
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";

  export default {
    computed: {
      ...mapGetters('merchantCentreSetupWizard', [
        'whitelabelStatus'
      ]),
      canContinueToSetup() {
        return this.whitelabelStatus.customDomainStatus === 'PENDING_SETUP';
      },
      unableToContinueMessage() {
        // TODO: Consider using custom_domain_message
        if (this.whitelabelStatus.customDomainStatus === 'PENDING') {
          return `
            Thanks! Your custom domain setup is underway. Please allow<strong> 5-10 minutes</strong> for this to complete. Until then, you won't be able to move forward. We'll notify you via
            email as soon as it's done.
           `;
        }
        return 'There was a problem setting up your custom domain, please contact '+
          '<a href="mailto:support@hikeseo.co">support@hikeseo.co</a> for more information.';
      },
    },
    mounted() {
      this.fetchWhitelabelStatus();
    },
    methods: {
      ...mapActions('merchantCentreSetupWizard', [
        'fetchWhitelabelStatus',
      ]),
    },
  }
</script>

<style lang="scss" scoped>

</style>
